import { render, staticRenderFns } from "./ViewPropagateBox.vue?vue&type=template&id=684aa2c6&"
import script from "./ViewPropagateBox.vue?vue&type=script&lang=js&"
export * from "./ViewPropagateBox.vue?vue&type=script&lang=js&"
import style0 from "./ViewPropagateBox.vue?vue&type=style&index=0&id=684aa2c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports